import { LinkExternal01Icon } from '@langchain/untitled-ui-icons';

import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { COLUMN_VISIBILITY } from '@/Pages/Project/constants';
import { UncontrolledRunsTable } from '@/components/RunsTable/UncontrolledRunsTable';
import { SplitViewPane } from '@/components/SplitViewPane';
import { Tooltip } from '@/design-system';
import { useOrganizationId } from '@/hooks/useSwr';
import { appSessionPath } from '@/utils/constants';
import { appProjectsPath } from '@/utils/constants';
import { appOrganizationPath } from '@/utils/constants';

const defaultColumnVisibility = {
  ...COLUMN_VISIBILITY.eval,
  reference_example_id: false,
  outputs: true,
  name: false,
};

export const TracingProjectPreview = ({
  isOpen,
  onClose,
  sessionId,
  tracingProjectTitle,
}: {
  isOpen: boolean;
  onClose: () => void;
  sessionId?: string;
  tracingProjectTitle: string;
}) => {
  const navigate = useNavigate();

  const runsFilter = useMemo(
    () => (sessionId ? { session: [sessionId] } : null),
    [sessionId]
  );

  const organizationId = useOrganizationId();
  const projectUrl = useMemo(() => {
    if (!sessionId) return null;

    const params = new URLSearchParams({
      test_run: 'true',
      timeModel: JSON.stringify({ duration: 'all' }),
    });

    return `/${appOrganizationPath}/${organizationId}/${appProjectsPath}/${appSessionPath}/${sessionId}?${params}`;
  }, [sessionId, organizationId]);

  return (
    <SplitViewPane
      open={isOpen}
      sidePaneId="tracing-project"
      onClose={onClose}
      title={
        <div className="flex w-full justify-between">
          <span>{tracingProjectTitle}</span>
          <Tooltip title="Open in project view">
            <button
              type="button"
              onClick={() => {
                if (projectUrl) {
                  navigate(projectUrl);
                }
              }}
            >
              <LinkExternal01Icon className="h-5 w-5" />
            </button>
          </Tooltip>
        </div>
      }
      className="m-2 overflow-y-auto overflow-x-hidden"
      hideArrows
    >
      {sessionId && (
        <UncontrolledRunsTable
          tableDisplay="list"
          runsFilter={runsFilter}
          defaultColumnVisibility={defaultColumnVisibility}
          defaultTimeModel={{
            duration: 'all',
          }}
        />
      )}
    </SplitViewPane>
  );
};
